import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools'
import EmployeeSearchForm from './search-form.js'

const EmployeeSearchModel = {
  nome: null
}

export default {
  mixins: [ActionsForm],
  name: 'EmployeeSearch',
  data () {
    return {
      data: EmployeeSearchModel,
      form: EmployeeSearchForm
    }
  },
  props: {
    parentComponent: {
      type: Object
    }
  },
  methods: {
    onLoad () {
      this.onClearFilters()
    },
    onClearFilters () {
      Tools.SetFormDefaultValues(this.form)
      this.parentComponent.filters = null
      this.parentComponent.onLoadAll()
    },
    onValidateFilters () {
      let result = true
      Tools.SetValueToSave(this.form, this.data)
      if (this.data.nome) this.data.nome = encodeURIComponent(this.data.nome)
      return result
    },
    onFilter () {
      if (this.onValidateFilters()) {
        this.$eventHub.emit('Filter', { filters: this.data })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/employee/components/search/search.js